import React from 'react';

interface IProps {
	visible?: boolean;
}

export const Footer: React.FC<IProps> = ({ visible }) => {
	return visible ? <footer className="text-grey-07-new">© {new Date().getFullYear()} KateMedia</footer> : null;
};
